//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    conductorConnectionStatus: {
      type: String,
      default () {
        return null
      }
    }
  },
  methods: {
    getConductorConnectionStatus: function () {
      if (this.conductorConnectionStatus === 'Работает') {
        return 'status-work'
      } else if (this.conductorConnectionStatus === 'Не работает') {
        return 'status-not-work'
      } else if (this.conductorConnectionStatus === 'Не определено') {
        return 'status-undefined'
      }
    }
  }
}

